import { communityBillingPath } from "@circle-react/helpers/urlHelpers";
import { useNavigate } from "@tanstack/react-router";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { accountSubscriptionApi } from "@/react/api/accountSubscriptionApi";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

interface Options {
  shouldRedirect?: boolean;
}

export const useAccountSubscriptionApi = ({
  shouldRedirect = true,
}: Options = {}) => {
  const { success, error } = useToast();
  const navigate = useNavigate();

  const { mutate: renewSubscription, isPending: isRenewLoading } = useMutation({
    mutationFn: (planId: number) => accountSubscriptionApi.renew(planId),
    onSuccess: () => {
      void navigate({ to: communityBillingPath() });
      success(t("pricing_plans.subscription_updated"));
    },
    onError: () => {
      error(t("pricing_plans.errors.renew_error"));
    },
  });

  const { mutate: updateSubscription, isPending: isUpdatingSubscription } =
    useMutation({
      mutationFn: (planId: number) => accountSubscriptionApi.update(planId),
      onSuccess: () => {
        if (shouldRedirect) void navigate({ to: communityBillingPath() });
        success(t("pricing_plans.subscription_updated"));
      },
      onError: () => {
        error(t("pricing_plans.errors.update_subscription_error"));
      },
    });

  const {
    mutate: reactivateEmailHubSubscription,
    isPending: isReactivatingEmailHubSubscription,
  } = useMutation({
    mutationFn: () => accountSubscriptionApi.reactivateEmailHubSubscription(),
    onSuccess: () => {
      success(t("pricing_plans.subscription_updated"));
    },
    onError: () => {
      error(t("pricing_plans.errors.update_subscription_error"));
    },
  });

  return {
    renewSubscription,
    isRenewLoading,
    updateSubscription,
    isUpdatingSubscription,
    reactivateEmailHubSubscription,
    isReactivatingEmailHubSubscription,
  };
};
